<template>
<div class="question-content" style="width:600px">
  <div class="dialog-head">
    <p class="dialog-head-title">{{typeFormData.title || '吸烟生活方式评估问卷'}}</p>
    <p class="dialog-head-tips">{{typeFormData.startRemark}}</p>
  </div>
  <div>
    <div style="display:flex">
      <div style="height:600px;width:619px" class="scroll-bar-view">
        <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
            <div v-for="(item,index) in typeFormData.questionAndItemList" :key="index">
                <h5>{{item.bigTitle}}</h5>
                <h1>
                  <span v-if="item.sort">{{item.sort}}.</span>{{item.description}}
                  <img style="width:80px;vertical-align: middle" v-if="item.questionPropertyVO && item.questionPropertyVO.urlList && item.questionPropertyVO.urlList[0]" :src="`${ossBaseUrl}${item.questionPropertyVO.urlList[0]}`">
                </h1>
                <div v-if="item.displayType == 4" style="color:gray;font-weight:bold;margin-left:15px">
                    <div>答案：{{ item.firstName ? item.firstName : '' }} {{ item.secondName ? item.secondName : '' }} {{ item.thirdName ? item.thirdName : '' }} {{ item.fourthName ? item.fourthName : '' }}</div>
                </div>
                <div style="color:gray" v-if="item.displayType === 17">
                  <span>答案 ：
                    <span>{{item.questionItemList[0].answerContent}}</span>
                    <span v-if="item.questionPropertyVO.type === 2" style="display:inline-block;margin:0 10px">~</span>
                    <span v-if="item.questionPropertyVO.type === 2">{{item.questionItemList[1].answerContent}}</span>
                  </span>
                </div>
                <div v-for="(son,index) in item.questionItemList" :key="index" style="margin-bottom:30px;color:#1A7BFC;font-weight:bold;text-indent: 15px;">
                    <!-- <span style="color:gray" v-if="item.displayType != 1 && item.displayType != 2 && item.displayType != 8 && item.displayType != 9 && item.displayType != 4 && item.displayType != 14">答案 ：{{ son.answerContent? son.answerContent : son.label }}</span> -->
                    <!-- <span style="color:gray" v-if="item.displayType == 1 || item.displayType == 2">答案 ：{{ son.answerContent? son.answerContent : son.label }} <span v-if="son.value" style="display:inline-block;margin-left:20px">其他 ：{{son.value}}</span> </span> -->
                    
                    <span style="color:gray" v-if="item.displayType != 17 && item.displayType != 8 && item.displayType != 9 && item.displayType != 4 && item.displayType != 14">
                      答案 ：{{ son.answerContent? son.answerContent : son.label }} <span v-if="son.needInput" style="display:inline-block;margin-left:20px">其他 ：{{son.value}}</span>
                      <img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`">
                    </span>
                    <div v-if="item.displayType == 8 || item.displayType == 9" style="color:gray">
                        <div>题目：{{ son.label }}<img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`"></div>
                        <div>
                          答案：{{ son.answerContent }}
                          <!-- <img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`"> -->
                        </div>
                    </div>
                    <span style="color:gray" v-if="item.displayType == 14">
                      <div class="img-item">
                        <img v-if="son.label" :src="`${ossBaseUrl}${son.label}`" style="height:90px">
                        <div>
                          <el-button size="small" style="margin-right:20px;" type="primary" @click="handleSyncImg(son.label)">图片同步对照录入</el-button>
                          <el-button size="small" style="border: 1px solid #1A7BFC;color:#1A7BFC" @click="handleLooklargeImg(son.label)">查看大图</el-button>
                        </div>
                      </div>
                      
                    </span>
                </div>
                <p v-if="item.displayType == 14" class="img-tips">* 上传图片支持PNG / JPG 格式，图片不能大于10M，最多可上传9张</p>
            </div>
            <div style="margin-top:10px;text-align:center;color: red;">{{ typeFormData.endRemark }}</div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { queryLevelList } from "@/api/addQuestionnaire"
export default({
  props: {
    showQuestion: {
      type: Boolean
    },
    typeFormDatas: {
      type: Object
    }
  },
  data() {
    return {
      placeholderList: [],
      value: '',
      ossBaseUrl: process.env.VUE_APP_OSS_URL, //预览图片基础路径
      scoreSetDatas: {
        examPaperScoreVOList: [
          {
            startScore: '',
            endScore: '',
            analysis: '',
            examPaperId: this.$route.query.id
          }
        ],
        showScore: ''
      },
      options: [],
      typeFormData: {}
    }
  },
  watch: {
    typeFormDatas:{
      handler(val, oldVal){
        this.typeFormData = JSON.parse(JSON.stringify(val))
        this.typeFormData.questionAndItemList.map((item) => {
          if (item.displayType === 2) {
            // item.selectCheckList = []
            this.$set(item, 'selectCheckList', [])
          }
          if (item.displayType === 4) {
            item.placeholderList = [{
              options: [{
                name: item.firstName,
                id: item.firstNameId
              }],
              value: item.firstNameId
            },{
              options: [],
              value: ''
            },{
              options: [],
              value: ''
            },{
              options: [],
              value: ''
            },
            ]
          }
        })
      },
      deep:true
    }
  },
  created() {
    this.typeFormData = JSON.parse(JSON.stringify(this.typeFormDatas))
    this.typeFormData.questionAndItemList.map((item) => {
      if (item.displayType === 2) {
        // item.selectCheckList = []
        this.$set(item, 'selectCheckList', [])
      }
      if (item.displayType === 4) {
        item.placeholderList = [{
          options: [{
            name: item.firstName,
            id: item.firstNameId
          }],
          value: item.firstNameId
        },{
          options: [],
          value: ''
        },{
          options: [],
          value: ''
        },{
          options: [],
          value: ''
        },
        ]
      }
    })
  },
  mounted() {},
  methods: {
    // 题型上的处理
    // 选择下拉项
    async changeSelect(val, item,item2, index1) {
      let res = await queryLevelList({
        level: index1 + 2,
        parentId: val,
        questionId: item.id,
        examPaperId: item.examPaperId
      })
      if (res.code === 0) {
        if (index1 !== 3) {
          this.$set(item.placeholderList[index1 + 1],'value','')
          this.$set(item.placeholderList[index1 + 1],'options',[])
        }
        if (index1 !== 3 && res.data.length) {
          this.$set(item.placeholderList[index1 + 1],'value',res.data[0].id)
          this.$set(item.placeholderList[index1 + 1],'options',res.data)
        }
        if (index1 === 0) {
          this.$set(item.placeholderList[2],'options',[])
          this.$set(item.placeholderList[2],'value','')
          this.$set(item.placeholderList[3],'options',[])
          this.$set(item.placeholderList[3],'value','')
        }
        if (index1 === 1) {
          this.$set(item.placeholderList[3],'options',[])
          this.$set(item.placeholderList[3],'value','')
        }
        this.$forceUpdate()
      }
    },
    // 聚焦下拉框
    async focusLevel(val, item) {
      let res = await queryLevelList({
        level: 1,
        parentId: 0,
        questionId: item.id,
        examPaperId: item.examPaperId
      })
      if (res.code === 0) {
        this.$set(item.placeholderList[0],'options',res.data)
        this.$forceUpdate()
      }
    }
  }
})
</script>
<style lang="less" scoped>
.el-radio,.el-checkbox {
  margin-bottom: 20px;
}
.el-select {
  margin-bottom: 20px;
}
div .el-input, span .el-input {
  margin-bottom: 20px;
}
p {
  margin-bottom: 15px;
}
.qs-title {
  // margin-bottom:20px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  // margin-top: 20px;
}
.dialog-head-title {
  // width: 260px;
  // height: 22px;
  font-size: 26px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-bottom: 8px;
  text-align: center;
}
.dialog-head-tips {
  // width: 168px;
  // height: 17px;
  font-size: 12px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  text-align: center;
}
// /deep/ .el-dialog__body {
//   max-height: 60vh;
//   overflow: auto;
//   padding: 30px;
//   padding-top: 0px;
// }
// /deep/ .el-dialog__title {
//   font-size: 26px;
//   font-weight: 500;
//   color: rgba(0, 0, 0, 0.85);
//   line-height: 22px;
//   padding: 30px;
// }
// /deep/ .el-dialog__footer {
//   padding: 30px;
// }
.tag {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 15px;
  display: flex;
}
.tag::before {
  content: '';
  display: block;
  width: 4px;
  height: 15px;
  background: #1A7BFC;
  margin-right: 15px;
  margin-top: 2.5px;
}
.add-item {
  width: calc(100% - 45px);
  background-color: #FCFCFC;
  border: 1px dashed #D9D9D9;
  color: #333333;
}
.score-set {
  display: flex;
}
.question-title {
  // width: 244px;
  // height: 22px;
  font-size: 14px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.option-icon {
  width: 30px;
  height: 30px;
  background: #F2F7FE;
  border-radius: 50%;
  display: inline-block;
  color: #1A7BFC;
  text-align: center;
  line-height: 30px;
  margin-left: 15px;
  cursor: pointer;
  margin-top: 5px;
}
// /deep/.el-dialog__footer {
//   text-align: left;
// }
.question-content {
  background-color: #F2F7FE;
  padding: 20px 50px;
  // height: 68vh;
  overflow: auto;
}
</style>

